var validator = {
    phoneValidator: [
        { required: true, message: '请输入联系电话', trigger: 'blur' },
    ],
    emailValidator: [
        { required: true, message: '请输入邮箱', trigger: 'blur' },
        {
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: '邮箱格式不正确',
            trigger: 'blur',
        },
    ],
    mobileValidator: [
        {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号格式不正确',
            trigger: 'blur',
        },
        { required: true, message: '请输入手机号', trigger: 'blur' },
    ],
}

export default validator
